import React, { useState, useEffect } from "react";
import axios from "axios";

const SpanishRiceAndBeansRecipeComponent = ({
  addIngredientsToCart,
  nameOfIngredients,
}) => {
  const [message, setMessage] = useState("");
  const [allItems, setAllItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    // Fetch all items from your API
    axios
      .get(`${process.env.REACT_APP_BACKEND_API}/products`)
      .then((response) => {
        setAllItems(response.data);
      })
      .catch((error) => {
        console.error("Error fetching all items:", error);
      });
  }, []);

  useEffect(() => {
    if (nameOfIngredients && nameOfIngredients.length > 0) {
      const filtered = allItems.filter((item) =>
        nameOfIngredients.includes(item.product_name)
      );
      setFilteredItems(filtered);
    }
  }, [nameOfIngredients, allItems]);

  const handleAddToCartClick = () => {
    try {
      const newItemAddedToFood = [];
      if (addIngredientsToCart && filteredItems.length > 0) {
        filteredItems.forEach((product) => {
          const food = {
            name: product.product_name,
            image: product.product_image,
            id: product.product_id,
            length: 1,
          };
          newItemAddedToFood.push(food);
        });

        addIngredientsToCart(newItemAddedToFood);

        setMessage("Ingredients have been added to your cart.");
      } else {
        setMessage("No specific ingredients selected to add to the cart.");
      }
    } catch (error) {
      console.error("Error adding ingredients to cart:", error);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 dark:text-white p-4 shadow-md rounded-lg">
      <div className="grid grid-cols-2">
        <div>
          <h3 className="text-2xl font-extrabold mb-8 text-center">
            Spanish Rice and Beans
          </h3>
          <img
            src="https://www.liveeatlearn.com/wp-content/uploads/2019/02/spanish-rice-beans-vert-500x375.jpg"
            alt="Spanish Rice and Beans"
            className="w-full h-60 object-contain"
          />
        </div>
        <div>
          <h3 className="text-xl font-bold mb-8">Ingredients</h3>
          <ul className="list-disc pl-6 mb-4">
            <li className="mb-4">1 cup long-grain white rice</li>
            <li className="mb-4">2 cups chicken or vegetable broth</li>
            <li className="mb-4">
              1 can (15 oz) black beans, drained and rinsed
            </li>
            <li className="mb-4">
              1 can (15 oz) diced tomatoes with green chilies
            </li>
            <li className="mb-4">1 small onion, diced</li>
            <li className="mb-4">1 bell pepper, diced</li>
            <li className="mb-4">2 cloves garlic, minced</li>
            <li className="mb-4">2 teaspoons ground cumin</li>
            <li className="mb-4">1 teaspoon chili powder</li>
            <li className="mb-4">1/2 teaspoon paprika</li>
            <li className="mb-4">Salt and pepper to taste</li>
            <li className="mb-4">Chopped fresh cilantro for garnish</li>
          </ul>
        </div>
      </div>

      <div>
        <h3 className="text-xl font-bold mb-8">Directions</h3>
        <ol className="pl-6 mb-4">
          <li className="mb-4">
            <strong className="text-xl">Step 1:</strong> In a large skillet,
            heat a bit of oil over medium heat. Add diced onions and bell
            peppers and sauté until softened, about 3-4 minutes.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 2:</strong> Add minced garlic and
            cook for an additional 30 seconds until fragrant.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 3:</strong> Add rice to the skillet
            and cook for 2-3 minutes, stirring occasionally until the rice is
            lightly toasted.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 4:</strong> Stir in chicken or
            vegetable broth, diced tomatoes with green chilies, black beans,
            ground cumin, chili powder, paprika, salt, and pepper. Bring to a
            boil.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 5:</strong> Reduce heat to low,
            cover, and simmer for 20-25 minutes or until the rice is cooked and
            the liquid is absorbed.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 6:</strong> Remove from heat and
            let it sit for 5 minutes. Fluff with a fork and garnish with chopped
            fresh cilantro before serving.
          </li>
        </ol>
      </div>

      <div className="flex justify-center">
        <button
          onClick={handleAddToCartClick}
          className="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900"
        >
          Add All Ingredients To Cart
        </button>
      </div>

      {message && <p className="mt-4">{message}</p>}
    </div>
  );
};

export default SpanishRiceAndBeansRecipeComponent;
